import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { initAnalytics, trackPageView, updateAnalyticsConsent } from "@/lib/analytics";
import { useCookieConsent } from "@/stores/useCookieConsent";

/**
 * GA4 の初期化・同意連動・SPA ルート遷移の page_view 送信をまとめたフック。
 * App 直下の null コンポーネントから 1 回だけ呼ぶ（Router 配下である必要がある）。
 */
export function useAnalytics(): void {
  const location = useLocation();
  const consent = useCookieConsent((state) => state.consent);
  const hasAnalyticsConsent = consent?.analytics === true;
  const isFirstRender = useRef(true);

  // 初期化は 1 回だけ。同意は未確定なので denied で開始する
  useEffect(() => {
    initAnalytics();
  }, []);

  // Cookie 同意の確定・変更を GA に反映
  useEffect(() => {
    updateAnalyticsConsent(hasAnalyticsConsent);
  }, [hasAnalyticsConsent]);

  // 初回描画分は gtag の config が自動送信するため、2 回目以降の遷移だけ送る。
  // document.title を @unhead が書き換えるのは同じコミットの別 effect なので、
  // マクロタスクへ 1 回逃がしてから送る（そうしないと遷移前のタイトルが記録される）。
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timerId = window.setTimeout(() => {
      trackPageView(`${location.pathname}${location.search}`);
    }, 0);

    return () => window.clearTimeout(timerId);
  }, [location.pathname, location.search]);
}
